const { displayMessage } = require("../../services/helper");

// module.exports = ['Continue assim!', 'Você está no caminho certo, continue assim!', 'Persista, o resultado virá', 'Não pare, você está quase lá!']
module.exports = [
    displayMessage('MOTIVATIONAL_PHRASE_1'),
    displayMessage('MOTIVATIONAL_PHRASE_2'),
    displayMessage('MOTIVATIONAL_PHRASE_3'),
    displayMessage('MOTIVATIONAL_PHRASE_4')
]